interface ActionType {
  GET_ARCGIS_PWD_START: string;
  GET_ARCGIS_PWD_SUCCESS: string;
  GET_ARCGIS_PWD_FAILURE: string;
  ADD_ARCGIS_PWD_START: string;
  ADD_ARCGIS_PWD_SUCCESS: string;
  ADD_ARCGIS_PWD_FAILURE: string;
  DELETE_ARCGIS_PWD_START: string;
  DELETE_ARCGIS_PWD_SUCCESS: string;
  DELETE_ARCGIS_PWD_FAILURE: string;
  RESET_ARCGIS_PWD: string;
}

export const ArcgisActionTypes: ActionType = {
  GET_ARCGIS_PWD_START: '@@GET_ARCGIS_PWD_START',
  GET_ARCGIS_PWD_SUCCESS: '@@GET_ARCGIS_PWD_SUCCESS',
  GET_ARCGIS_PWD_FAILURE: '@@GET_ARCGIS_PWD_FAILURE',
  ADD_ARCGIS_PWD_START: '@@ADD_ARCGIS_PWD_START',
  ADD_ARCGIS_PWD_SUCCESS: '@@ADD_ARCGIS_PWD_SUCCESS',
  ADD_ARCGIS_PWD_FAILURE: '@@ADD_ARCGIS_PWD_FAILURE',
  DELETE_ARCGIS_PWD_START: '@@DELETE_ARCGIS_PWD_START',
  DELETE_ARCGIS_PWD_SUCCESS: '@@DELETE_ARCGIS_PWD_SUCCESS',
  DELETE_ARCGIS_PWD_FAILURE: '@@DELETE_ARCGIS_PWD_FAILURE',
  RESET_ARCGIS_PWD: '@@RESET_ARCGIS_PWD'
};

export interface ArcgisState {
  accessCredentials?: ArcgisAccessCredentials;
}

export interface ArcgisAccessCredentials {
  username?: string;
  password?: string;
  processing?: 'adding' | 'getting' | 'deleting';
  error?: string;
}
